/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThresholdConfig
 */
export interface ThresholdConfig {
    /**
     * 
     * @type {number}
     * @memberof ThresholdConfig
     */
    warningMin?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdConfig
     */
    warningMax?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdConfig
     */
    criticalMin?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdConfig
     */
    criticalMax?: number;
    /**
     * 
     * @type {string}
     * @memberof ThresholdConfig
     */
    unit?: string;
}

/**
 * Check if a given object implements the ThresholdConfig interface.
 */
export function instanceOfThresholdConfig(value: object): value is ThresholdConfig {
    return true;
}

export function ThresholdConfigFromJSON(json: any): ThresholdConfig {
    return ThresholdConfigFromJSONTyped(json, false);
}

export function ThresholdConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThresholdConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'warningMin': json['warningMin'] == null ? undefined : json['warningMin'],
        'warningMax': json['warningMax'] == null ? undefined : json['warningMax'],
        'criticalMin': json['criticalMin'] == null ? undefined : json['criticalMin'],
        'criticalMax': json['criticalMax'] == null ? undefined : json['criticalMax'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function ThresholdConfigToJSON(value?: ThresholdConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'warningMin': value['warningMin'],
        'warningMax': value['warningMax'],
        'criticalMin': value['criticalMin'],
        'criticalMax': value['criticalMax'],
        'unit': value['unit'],
    };
}

